import React from "react";
import { View, SafeAreaView } from "react-native";
import StyledText from "../components/common/ui/styled-text";
import { BarChart2 } from "lucide-react-native";

export default function ReportsPage() {
  return (
    <SafeAreaView className="flex-1 bg-white">
      <View className="flex-1 items-center justify-center p-8">
        <View className="items-center max-w-md">
          <View className="w-20 h-20 bg-blue-50 rounded-full items-center justify-center mb-6">
            <BarChart2 size={40} color="#3B82F6" />
          </View>
          <StyledText className="text-3xl font-bold text-gray-900 text-center mb-4">
            Reports
          </StyledText>
          <StyledText className="text-lg text-gray-600 text-center mb-8 leading-relaxed">
            We're working hard to bring you comprehensive analytics and
            insights. This feature will help you track performance, analyze
            trends, and make data-driven decisions for your business.
          </StyledText>
          <View className="bg-blue-100 px-4 py-2 rounded-full">
            <StyledText className="text-blue-800 font-medium">
              Coming Soon
            </StyledText>
          </View>
        </View>
      </View>
    </SafeAreaView>
  );
}
